import { render, staticRenderFns } from "./ColumnPostAuthors.vue?vue&type=template&id=5c62fa48&"
import script from "./ColumnPostAuthors.vue?vue&type=script&lang=js&"
export * from "./ColumnPostAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports